import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

import { useRouteHelpers } from "@/react/routes/Main/useRouteHelpers";
import { useSitePageMetadata } from "@/react/routes/Main/useSitePageMetadata";
import {
  disablePendoGuides,
  enablePendoGuides,
} from "@/react/utils/pendoUtils";

export function usePendoGuideModalShow() {
  const location = useLocation();
  const { isSitePageRoute } = useSitePageMetadata();
  const { isLivePage } = useRouteHelpers();

  useEffect(() => {
    const isDisabled = isSitePageRoute || isLivePage;
    if (isDisabled) disablePendoGuides();
    else enablePendoGuides();
  }, [isSitePageRoute, isLivePage, location.pathname]);
}
